"use strict";const t=require("./index18.js"),r=require("./index77.js");var e=t._export,o=r.functionCall;e({target:"URL",proto:!0,enumerable:!0},{toJSON:function(){return o(URL.prototype.toString,this)}});
